/* eslint-disable @typescript-eslint/no-explicit-any */
import { Observable } from 'rxjs';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiParams } from '@shared/models';
import { StorageService } from '../storage/storage.service';

const API_BASE_URL = environment.apiBaseUrl;

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public userPath: string = '';

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
  ) {
    this.getUserPath();
  }

  async getUserPath() {
    const token = await this.storageService.get(environment.tokenName);
    this.userPath = token ? 'user/' : '';
  }

  get<T>(url: string, params?: ApiParams): Observable<T> {
    let httpParams: HttpParams = new HttpParams();

    if (params) {
      if (params.query) {
        Object.keys(params.query).forEach((key) => {
          const value = params.query![key];
          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              httpParams = httpParams.append(`${key}[${index}]`, item.toString());
            });
          } else if (value !== undefined) {
            httpParams = httpParams.set(key, value.toString());
          }
        });
      }

      if (params.attributes) {
        params.attributes.forEach((attr) => {
          httpParams = httpParams.append('attributes', attr);
        });
      }

      if (params.inline) {
        params.inline.forEach((inline) => {
          httpParams = httpParams.append('inline', inline);
        });
      }

      if (params.page !== undefined) {
        httpParams = httpParams.set('page', params.page.toString());
      }

      if (params.timeout !== undefined) {
        httpParams = httpParams.set('timeout', params.timeout.toString());
      }
    }

    return this.http.get<T>(`${API_BASE_URL}${url}`, { params: httpParams });
  }

  post<T>(url: string, data: any): Observable<T> {
    return this.http.post<T>(`${API_BASE_URL}${url}`, data);
  }

  put<T>(url: string, data: any): Observable<T> {
    return this.http.put<T>(`${API_BASE_URL}${url}`, data);
  }

  delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(`${API_BASE_URL}${url}`);
  }
}
